module.exports = __webpack_public_path__ + "static/media/gift-oval.e3409717.svg";